import { useMemo } from "react";

import ModalSkeleton from "../../../Components/Skeleton/modal-skeleton";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useCreditReportDetails } from "../../../CustomHooks/Queries";

import { modalVariants, monthNames } from "../../../Utils/constants";

import renderCreditBuilderOptOut from "./credit-builder-opt-out";

export default function renderCreditBuilderTracker(modalContext) {
  const { updateModalComponent, setModalVariant, setModalTitle, setModalClassName } = modalContext;

  updateModalComponent(CreditBuilderTracker);
  setModalVariant(modalVariants.infoDialog);
  setModalTitle("Credit Builder Tracker");
  setModalClassName("cbt-modal");
}

function StatusIcon({ isReported }) {
  if (isReported) {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="7" fill="#1A3A2A" stroke="#54FF99" strokeWidth="0.8" />
        <path d="M5 8l2 2 4-4" stroke="#54FF99" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="7" fill="#3A2A1A" stroke="#C4873B" strokeWidth="0.8" />
      <path d="M8 4.5v4" stroke="#C4873B" strokeWidth="1.2" strokeLinecap="round" />
      <circle cx="8" cy="11.5" r="0.7" fill="#C4873B" />
    </svg>
  );
}

function ChevronRight() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M5 3l4 4-4 4" stroke="#4E5364" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const CreditBuilderTracker = () => {
  const modalContext = useModalContext();
  const { isLoading: isLoadingCreditReporting, data: creditReporting } = useCreditReportDetails();

  const creditBuilderTrackerList = useMemo(() => {
    return creditReporting?.data?.data.credit_builder_tracker ?? [];
  }, [creditReporting?.data?.data.credit_builder_tracker]);

  return isLoadingCreditReporting ? (
    <ModalSkeleton />
  ) : (
    <>
      <div className="cbt-body">
        {creditBuilderTrackerList.map((payment, idx) => {
          const isReported = payment?.is_reported ?? false;
          return (
            <div key={idx} className="cbt-row">
              <div className="cbt-icon">
                <StatusIcon isReported={isReported} />
              </div>
              <div className="cbt-text">
                <span className="cbt-month">
                  {`${monthNames[parseInt(payment.month) - 1] || ""} ${payment.year}`}
                </span>
                <span className="cbt-status">{payment?.description}</span>
              </div>
              <ChevronRight />
            </div>
          );
        })}
      </div>
      <div className="cbt-footer">
        <button
          className="cbt-opt-out-btn"
          onClick={() => renderCreditBuilderOptOut(modalContext)}
        >
          Turn Off Credit Builder
        </button>
      </div>
    </>
  );
};
